import React from 'react';
import {
  Button,
  ButtonColor,
  ButtonSize, useListContextRequired,
  useMassUpdateServiceRequired,
  usePopupManager
} from 'ui-builder';
import { ConfirmPositiveActionPopup } from 'features/nekst-widgets';
import { useWebhookMonitoringService } from 'nekst-api';

export default function RepeatRequestButton() {

  const massUpdateService = useMassUpdateServiceRequired<string>();

  const popupManager = usePopupManager();

  const webhookService = useWebhookMonitoringService();

  const listContext = useListContextRequired();

  return (
    <Button
      text="Repeat Requests"
      isDisabled={massUpdateService.getCheckedIds().length === 0}
      onClick={async () => {
        popupManager.openPopup(
          <ConfirmPositiveActionPopup
            title="Repeat Requests"
            message="Are you sure you want to repeat the selected requests?"
            submitFormFunc={async () => {
              const data = await webhookService.repeatRequest(massUpdateService.getCheckedIds());
              listContext._updateItems(data);
            }}
          />
        )
      }}
      color={ButtonColor.GRAY}
      size={ButtonSize.SMALL}
      isFlat
      isFilled
    />
  );
}
